import * as Actions from 'app/store/actions/brands';

const initialState = {
  data: []
};

const brandsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_BRANDS: {
      return {
        ...state,
        data: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default brandsReducer;
